import React from 'react';
import styled from 'styled-components';

const NoRecordsFound = () => {
    return (
      <Wrapper>
        <Title>No records found</Title>
        <Hint>Try adjusting your filters or check back later.</Hint>
      </Wrapper>
    );
};

export default NoRecordsFound;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 56px 24px;
  text-align: center;
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, Roboto, sans-serif;
`;

const Title = styled.div`
  font-size: 1rem;
  font-weight: 600;
  color: var(--neutral-700);
`;

const Hint = styled.div`
  font-size: 0.875rem;
  color: var(--neutral-500);
`;
